module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAABQCAYAAABrjzfBAAABLUlEQVRoQ+3YMQrCQBCF4bdgbeEVBI9jKdh5NM/gwSy8wEggheVu3ptx0Zc6A1/+TLFsw+RPm9wHA9k/5IIuyBZg572DLsgWYOe9gy7IFmDnvYMuyBZg572DLvhZICL2AM4AHq21F1unZ757B1fcDcABwBPAvQI5AjwCuALYrV9eguwGLqiIOAG4VCKHgN9ADgOrkZuAlcjNwCokBaxA0sBspASYiZQBs5BSYAZSDlQjU4BKZBpQhUwFKpD/DVQcz9IKKnDLiqQAVbgUoBInB6pxUmAGTgbMwkmAmTgamI2jgBW4zcAq3CZgJW4YWI0bAkbE3JdH01+/rYfPeS8we25DM95JOW4poQayNV3QBdkC7Lx30AXZAuy8d9AF2QLsvHfQBdkC7Lx38OcLvgEXuspRwib64AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home/xiangyou_active.png
// module id = eDNk
// module chunks = 1